export default "__VITE_ASSET__Ch3dh_w2__"